module.exports = __webpack_public_path__ + "static/mexi-cobb-salads-d6048058d6e64ff9e1f98813a27142ac.jpg";